import { NOTIFICATION_CATEGORIES } from '~/utils/constants'

export default {
  computed: {
    notificationToRead() {
      return this.isNotificationToRead(this.message)
    },
    notificationToBeAccepted() {
      return this.isNotificationToBeAccepted(this.message)
    },
    getDialogHeaderClasses() {
      if (!this.message) return ''

      let classes = ''

      if (this.message.category === NOTIFICATION_CATEGORIES.PROMOTION) {
        classes = 'bg-preview-promotion'
      } else if (this.message.category === NOTIFICATION_CATEGORIES.CRITICAL) {
        classes = 'bg-preview-critical'
      } else if (this.message.category === NOTIFICATION_CATEGORIES.SYSTEM) {
        classes = 'bg-preview-system'
      } else if (this.message.category === NOTIFICATION_CATEGORIES.ACADEMY) {
        classes = 'bg-preview-academy'
      } else if (
        this.message.category === NOTIFICATION_CATEGORIES.PERSONALIZED
      ) {
        classes = 'bg-preview-personalized'
      }

      if (this.message.category === NOTIFICATION_CATEGORIES.ACADEMY) {
        classes += ' text-white'
      }
      return classes
    },
  },
  methods: {
    isNotificationToRead(message) {
      return message?.readAt === null
    },
    isNotificationToBeAccepted(message) {
      return message?.toBeAccepted !== 0
    },
    isNotificationExpired(message) {
      return message?.isExpired === true
    },
    isCriticalNotification(message) {
      return message?.category === NOTIFICATION_CATEGORIES.CRITICAL
    },
    getRowBgClass(message) {
      if (!message || !this.isNotificationToRead(message)) return ''

      if (message.category === NOTIFICATION_CATEGORIES.PROMOTION) {
        return 'bg-msg-promotion'
      } else if (message.category === NOTIFICATION_CATEGORIES.CRITICAL) {
        return 'bg-msg-critical'
      } else if (message.category === NOTIFICATION_CATEGORIES.SYSTEM) {
        return 'bg-msg-system'
      } else if (message.category === NOTIFICATION_CATEGORIES.ACADEMY) {
        return 'bg-msg-academy'
      } else if (message.category === NOTIFICATION_CATEGORIES.PERSONALIZED) {
        return 'bg-msg-personalized'
      } else return ''
    },
    getIconClass(message) {
      if (!message) return ''

      if (message.category === NOTIFICATION_CATEGORIES.PROMOTION) {
        return 'fa-solid fa-bullhorn'
      } else if (message.category === NOTIFICATION_CATEGORIES.CRITICAL) {
        return 'fa fa-circle-exclamation text-danger'
      } else if (message.category === NOTIFICATION_CATEGORIES.SYSTEM) {
        return 'fa fa-circle-exclamation text-warning'
      } else if (message.category === NOTIFICATION_CATEGORIES.ACADEMY) {
        return 'fa fa-graduation-cap'
      } else if (message.category === NOTIFICATION_CATEGORIES.PERSONALIZED) {
        return 'fa-regular fa-envelope'
      } else return ''
    },
    getIconBorderColor(message) {
      if (!message) return 'border-icon-default'

      if (message.category === NOTIFICATION_CATEGORIES.PROMOTION) {
        return 'border-icon-promotion'
      } else if (message.category === NOTIFICATION_CATEGORIES.CRITICAL) {
        return 'border-icon-critical'
      } else if (message.category === NOTIFICATION_CATEGORIES.SYSTEM) {
        return 'border-icon-system'
      } else if (message.category === NOTIFICATION_CATEGORIES.ACADEMY) {
        return 'border-icon-academy'
      } else if (message.category === NOTIFICATION_CATEGORIES.PERSONALIZED) {
        return 'border-icon-personalized'
      } else return 'border-icon-default'
    },
    openDetailModal() {
      this.$refs['notification-detail-modal'].showModal()
    },
    markMessageAsRead(ok) {
      this.markThisMessageAsRead(this.message)
      ok()
    },
    remindLater(ok) {
      ok()
    },
    async markThisMessageAsRead(message) {
      if (this.isNotificationToRead(message)) {
        await this.$store.dispatch('messages/markMessageAsRead', message.id)
        this.$emit('markedAsRead')
      }
    },
  },
}
